@if (categories().length) {
<section class="d-flex align-items-center bg-sky-light fullwidth-section">
  <div
    class="app-container container-xl container-xl-max-md d-flex flex-column justify-content-center w-100 py-12 my-8">
    <div #header class="d-flex flex-column justify-content-center fw-bold mb-12">
      <p class="fs-2hx mb-0 text-center">
        {{ "LANDING_PAGE.COURSE_CATEGORY" | translate }}
      </p>
      <p class="fs-5 fw-normal text-gray-600 text-center mt-3 mb-0">
        {{ "LANDING_PAGE.COURSE_CATEGORY_DESC" | translate }}
      </p>
    </div>

    <div class="row row-cols-2 row-cols-md-4 g-5 justify-content-center" data-testid="landing-categories">
      @for (category of categories(); track category.id; let i = $index) {
      @if(i+1<= 4){ <div class="col d-flex">
        <a class="card flex-1 hover-elevate-up text-inherit" [routerLink]="['/courses/category', category.id]">
          <div class="card-body d-flex flex-column">
            <!-- Bigger and ringed. Four small tinted squares read as a legend;
                     at this size they read as the way in, and the colour rotation is
                     the only place on the page allowed to be loud. -->
            <!-- The colour rotation is for the letter fallback. Where there is
                     art, the art carries the colour and the well goes neutral —
                     four tinted wells behind four multi-colour icons is two colour
                     systems fighting in one row. -->
            <div class="category-mark d-flex align-items-center justify-content-center mb-5 fs-2hx fw-bold"
              [ngClass]="icon(category) ? 'category-mark--art' : 'bg-light-' + tint(i) + ' text-' + tint(i)">
              @if (icon(category); as art) {
              <img [src]="art" [alt]="category.name" class="category-mark__art" />
              } @else {
              {{ initial(category) }}
              }
            </div>
            <div class="fs-4 fw-bold text-gray-900 mb-2">{{ category.name }}</div>
            @if (showDescriptions() && category.description) {
            <div class="fs-7 text-gray-600 text-overflow-line-2">{{ category.description }}</div>
            }
            <div class="mt-auto pt-4 category-go">
              {{ "LANDING_PAGE.SEE_COURSES" | translate }}
              <span class="category-go__arrow" aria-hidden="true">→</span>
            </div>
          </div>
        </a>
    </div>

    }
    }
  </div>
  </div>
</section>
}